export default __webpack_public_path__ + "static/media/glob.f370bf8c.png";